
export default {
  props: {
    action: {
      type: String,
      required: false,
      default: 'button',
    },
    icon: {
      default: undefined,
      type: String,
    },
    size: {
      type: String,
      required: false,
      default: 'large',
    },
    to: {
      default: null,
      type: [Object, String],
    },
    href: {
      default: null,
      type: String,
    },
  },

  computed: {
    shouldSubmit() {
      return this.action === 'submit' && !this.to;
    },
  },

  methods: {
    click() {
      this.$emit('click');

      if (this.to) {
        this.$router.push(this.to);
      }

      if (this.href) {
        window.open(this.href, '_blank');
      }
    },
  },
};
